import { ReactComponent as Logo } from '../../assets/icons/address book 1.svg'

const Book = () => {
    return <Logo width={20} height={20} fill='white' />
}

export default Book
